import {
  Command,
  CommandProvider,
  GetCommandsProps,
  ModuleRenderer,
  ProviderConfig,
} from "common/app/command-palette/types";

export abstract class BaseCommandProvider implements CommandProvider {
  protected setModuleRenderer: (renderer: ModuleRenderer) => void;
  protected onCommandsChanged: () => void;

  abstract getCommands(props: GetCommandsProps): Command[] | Promise<Command[]>;

  constructor(config: ProviderConfig) {
    this.setModuleRenderer = config.setModuleRenderer;
    this.onCommandsChanged = config.onCommandsChanged;
  }

  isModuleProvider() {
    return false;
  }

  dispose() {
    // Implement this method in the derived class when needed
  }
}
